export default __webpack_public_path__ + "static/media/foiunders.763e56fa.png";